import { z } from 'zod';
import {
  ReferralStoredDocumentsSchema,
  filterReferralDocumentsOfType,
} from '../ReferralDocumentsSchema';
import { ReferralDocumentType } from '../../enums';

// The documents of an Aviva referral: the shared typed array (PPL-3549), plus
// the referral form Aviva always sends — it carries the diagnosis, so a
// referral without any supporting document cannot be worked on.
export const ReferralAvivaDocumentsSchema =
  ReferralStoredDocumentsSchema.refine(
    (documents) =>
      filterReferralDocumentsOfType(documents, ReferralDocumentType.supporting)
        .length > 0,
    'At least one referral form is required',
  );

export type ReferralAvivaDocuments = z.infer<
  typeof ReferralAvivaDocumentsSchema
>;
